export function mascaraRenspa(renspa) {
    let formato = '';
    if (renspa) {
        const apenasNumeros = renspa.replace(/\D/g, '');

        formato = apenasNumeros.replace(
            /^(\d{2})(\d{3})(\d{1})(\d{5})(\d{2})$/,
            '$1.$2.$3.$4/$5'
        );
    }
    return formato;
}
